import React, { Component } from 'react';
import axios from 'axios';
import Helmet from 'react-helmet';

const initialState = {
  phonenumber: '',
  authCode: '',
  onetimeTid: '',
  dispKbn: 0,
  errorMap: null,
  loading: false
}

class MobilenumberChange extends Component {
  state = initialState;

  componentDidMount() {

    // GA計測用データレイヤースクリプトを追加する
    window.addDataLayerScript('jmbauth_otp_send_confirmation_code');

  }

  // 携帯電話番号登録変更開始画面[送信する]ボタン押下処理
  send = async () => {

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');
    // アクショントークン格納変数の宣言
    let actionToken = null;

    // SDK呼出(アクションレポート)
    try{
      // アクションのレポート作成
      const actionPromise = window.tsPlatform.drs.triggerActionEvent("account_details_change_mobilenumberstart", { correlationId: l_sid });

      // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
    }catch(e){
      // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // バリデーションチェックを行う
    let phonenumber = document.getElementById('LB_input-tel').value;
    if (phonenumber === '') {
      this.setState({ errorMap: { ERROR: messageList.moblienumberChange.M017_errorMessage001, errorId: ['phonenumber'] } });
      return;
    }
    const otpMobilenumber = sessionStorage.getItem('OTPMOBILENUMBER');
    if (otpMobilenumber !== '' && otpMobilenumber === phonenumber) {
      this.setState({ errorMap: { ERROR: messageList.moblienumberChange.M018_errorMessage002, errorId: ['phonenumber'] } });
      return;
    }

    // 携帯電話番号登録・変更SMS送信要求を行う
    try {

      // ローディング開始
      this.setState({ loading: true });

      // 携帯電話番号登録・変更SMS送信要求API
      axios.post(process.env.REACT_APP_URL_CO_SC_API_MOBILENUMBER,
        {
          phonenumber: phonenumber
        },
        {
          headers: {
            'accept-language': window.changeLang(sessionStorage.getItem("lang")),
            'Cache-Control': 'no-store',
            'Pragma': 'no-cache'
          }
        }
      )
        .then(response => {

          this.setState({ errorMap: null, onetimeTid: response.data.onetimeTid, dispKbn: 1, loading: false, phonenumber: phonenumber, authCode:'' });
          // GA計測用データレイヤースクリプトを追加する
          window.addDataLayerScript('jmbauth_otp_input_confirmation_code');

        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 400) {
              this.setState({
                errorMap:
                  { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.moblienumberChange.M019_errorMessage003 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location = "#JS_error";
            }
            else if (error.response.status === 401) {
              this.setState({
                errorMap:
                  { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.moblienumberChange.M019_errorMessage003 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location = "#JS_error";
            }
            else if (error.response.status === 500) {

              // エラー画面に遷移し、処理を終了する
              this.props.history.push({
                pathname: `${process.env.REACT_APP_CONTEXT_PATH}/error`
              });
            }
            else {
              this.setState({
                errorMap:
                  { ERROR: messageList.moblienumberChange.M019_errorMessage003 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location = "#JS_error";
            }
          }
          else {
            this.setState({
              errorMap:
                { ERROR: messageList.moblienumberChange.M019_errorMessage003 },
              loading: false
            });
            // エラーメッセージ表示領域に遷移する
            window.location = "#JS_error";
          }
        });

    } catch (err) {
      console.error(err);
      this.setState({
        errorMap:
          { ERROR: messageList.moblienumberChange.M019_errorMessage003 },
        loading: false
      });
      // エラーメッセージ表示領域に遷移する
      window.location = "#JS_error";

    } finally {
    }
  }

  // 携帯電話番号登録変更画面[送信する]ボタン押下処理
  change = async () => {

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');
    // アクショントークン格納変数の宣言
    let actionToken = null;

    // SDK呼出(アクションレポート)
    try{
      // アクションのレポート作成
      const actionPromise = window.tsPlatform.drs.triggerActionEvent("account_details_change_mobilenumberchange", { correlationId: l_sid });

      // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
    }catch(e){
      // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    let messageList = JSON.parse(sessionStorage.getItem('messageList'));
    let authCode = document.getElementById('LB_input-tel').value;
    if (authCode === '') {
      this.setState({ errorMap: { ERROR: messageList.moblienumberChangeSetting.M015_errorMessage001, errorId: ['authCode'] } });
      return;
    }

    // 携帯電話番号登録・変更要求を行う
    try {

      // ローディング開始
      this.setState({ loading: true });

      // 携帯電話番号登録・変更API
      axios.put(process.env.REACT_APP_URL_CO_SC_API_MOBILENUMBER_CHANGE,
        {
          onetimeTid: this.state.onetimeTid,
          authCode: authCode
        },
        {
          headers: {
            'accept-language': window.changeLang(sessionStorage.getItem("lang")),
            'Cache-Control': 'no-store',
            'Pragma': 'no-cache'
          }
        }
      )
        .then(response => {

          this.setState({ phonenumber: '', authCode: '', onetimeTid: '', errorMap: null, dispKbn: 2, loading: false });
          // GA計測用データレイヤースクリプトを追加する
          window.addDataLayerScript('jmbauth_otp_mobile_number_completion');
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 400) {
              this.setState({
                errorMap:
                  { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.moblienumberChangeSetting.M016_errorMessage002 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location = "#JS_error";
            }
            else if (error.response.status === 401) {
              this.setState({
                errorMap:
                  { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.moblienumberChangeSetting.M016_errorMessage002 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location = "#JS_error";
            }
            else if (error.response.status === 403) {
              this.setState({
                errorMap:
                  { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.moblienumberChangeSetting.M016_errorMessage002 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location = "#JS_error";
            }
            else if (error.response.status === 500) {

              // エラー画面に遷移し、処理を終了する
              this.props.history.push({
                pathname: `${process.env.REACT_APP_CONTEXT_PATH}/error`
              });
            }
            else {
              this.setState({
                errorMap:
                  { ERROR: messageList.moblienumberChangeSetting.M016_errorMessage002 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location = "#JS_error";
            }
          }
          else {
            this.setState({
              errorMap:
                { ERROR: messageList.moblienumberChangeSetting.M016_errorMessage002 },
              loading: false
            });
            // エラーメッセージ表示領域に遷移する
            window.location = "#JS_error";
          }
        });

    } catch (err) {
      console.error(err);
      this.setState({
        errorMap:
          { ERROR: messageList.moblienumberChangeSetting.M016_errorMessage002 },
        loading: false
      });
      // エラーメッセージ表示領域に遷移する
      window.location = "#JS_error";

    } finally {
    }
  }

  // OTP通知先変更画面へ戻る処理
  beforeOtpChange = () => {
    window.location.href = `${process.env.REACT_APP_CONTEXT_PATH}/menu/otp_auth?design=` + sessionStorage.getItem('design') + "&lang=" + sessionStorage.getItem('lang');
  }

  beforeMobilenumberChange = () => {
    this.setState({ onetimeTid: '', dispKbn: 0, errorMap: null });
  }

  handleChange = e => {
    this.setState({ [e.currentTarget.name]: e.currentTarget.value.trim() });
  }

  // Enterキー押下時処理
  handleKeyPress = e => {
    if(e.key === "Enter"){
      e.preventDefault();
      if(this.state.dispKbn === 0){
        this.send();
      }else if(this.state.dispKbn === 1){
        this.change();
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.dispKbn !== this.state.dispKbn && this.state.dispKbn === 1){
      if ("OTPCredential" in window) {
        const ac = new AbortController();
        navigator.credentials
          .get({
            otp: { transport: ["sms"] },
            signal: ac.signal,
          })
          .then((otp) => {
            this.setState({ authCode : otp.code });
          })
          .catch((err) => {
          });
      }
    }
  }

  // 画面をクローズする
  close = e => {
    window.open('about:blank', '_self').close();
  }

  toPasskey = e => {
    window.location.href = `${process.env.REACT_APP_CONTEXT_PATH}/menu/fido/top?design=` + sessionStorage.getItem('design') + "&lang=" + sessionStorage.getItem('lang');
  }

  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    const boxStyle = {
      visibility:"hidden",
      width:"1px",
      height:"1px"
    };

    // 携帯電話番号登録遷移区分を取得する
    const { REGIST_TRANS_TYPE } = this.props.params;

    // 携帯電話番号登録変更開始画面表示
    if (this.state.dispKbn === 0) {
      return (
        <section className="content">
          {
            REGIST_TRANS_TYPE === "REGIST_GUID"
              ? <Helmet title={messageList.moblienumberChange.M001_browserTitle_regist}></Helmet>
              : <Helmet title={messageList.moblienumberChange.M001_browserTitle}></Helmet>
          }

          { // Loadingモーダル表示
            this.state.loading &&
            <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading" /></div>
          }

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 className="ds-heading__title">{messageList.moblienumberChange.M002_pageTitle}</h1>
          </div>

          <div className="contentInner">
            {/* サブタイトル表示部 */}
            <div className="ds-heading ds-heading--sm">
              <h2 className="ds-heading__title">
                {
                  REGIST_TRANS_TYPE === "REGIST_GUID"
                    ? messageList.moblienumberChange.M003_pageTitleSub_regist
                    : messageList.moblienumberChange.M003_pageTitleSub
                }
              </h2>
            </div>

            <p className="ds-text">{messageList.moblienumberChange.M004_mobileNumberChangeText001}</p>

            {/* 注意書きリスト */}
            <ul className="ds-listText">
              <li className="ds-listText__item ds-listText__item--note">
                {
                  REGIST_TRANS_TYPE === "REGIST_GUID"
                    ? messageList.moblienumberChange.M005_mobileNumberChangeText002_regist
                    : messageList.moblienumberChange.M005_mobileNumberChangeText002
                }<br />
                {messageList.moblienumberChange.M006_mobileNumberChangeText003}
              </li>
            </ul>

            <div id="JS_error">
              { // エラーメッセージ表示
                (this.state.errorMap && this.state.errorMap.ERROR) &&
                <div className="ds-inlineNote ds-inlineNote--attention u-mb-32--pc" role="alert" aria-live="assertive">
                  <div className="ds-inlineNote__details">
                    <div className="ds-inlineNote__summary">
                      <h2 className="ds-inlineNote__heading">
                        <span className="ds-inlineNote__headingIcon">
                          <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.moblienumberChange.M007_errorIconText}>
                            <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                          </svg>
                        </span>
                        <span className="ds-inlineNote__headingLabel">{messageList.moblienumberChange.M008_errorBoxTitle}</span>
                      </h2>
                    </div>
                    <div className="ds-inlineNote__content">
                      <p className="ds-text">{this.state.errorMap.ERROR}</p>
                    </div>
                  </div>
                </div>/* /ds-inlineNote */
              }
            </div>

            <div className="formPanel">
              <div className="formPanel__inner">
                <form name="form">
                  <div className="formWrap">
                    <label className="formLabel" htmlFor="LB_input-tel">
                      <span className="formLabel__text">{messageList.moblienumberChange.M021_telLabel}</span>
                    </label>
                    <input id="LB_input-tel" name="phonenumber"
                      className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('phonenumber') ?
                        "ds-textfield is-error" : "ds-textfield"}
                      type="tel" required
                      aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('phonenumber') ? "true" : "false"}
                      aria-describedby="LB_input-tel-helper"
                      autoComplete="tel" maxLength="11"
                      value={this.state.phonenumber} onChange={this.handleChange} onKeyPress={this.handleKeyPress} />
                    <span id="LB_input-tel-helper" className="helperText">{messageList.moblienumberChange.M022_telHelperText}</span>
                  </div>

                  <p className="ds-text ds-text--md u-mt-24">{messageList.moblienumberChange.M010_mobileNumberChangeText005}</p>

                  <a href={messageList.moblienumberChange.M020_noticeUrl001} target="_blank" rel="noopener noreferrer" className="ds-textLink ds-textLink--linkBlank u-fw-bold">
                    {messageList.moblienumberChange.M012_otpPassword}&nbsp;
                    <span className="ds-textLink__icon">
                      <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.moblienumberChange.M011_newWindowIcon}>
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                      </svg>
                    </span>
                  </a>

                  {/* 送信ボタン */}
                  <div className="buttonLayout">
                    <div className="buttonWrap buttonWrap--center">
                      <div className="ds-button ds-button--primary ds-button--large">
                        <button className="ds-button__trigger" type="button" formNoValidate onClick={this.send}>
                          <span className="ds-button__label">{messageList.moblienumberChange.M013_send}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* 戻る / 閉じるボタン */}
            <div className="buttonLayout">
              <div className="buttonWrap buttonWrap--left">
                <div className="ds-button ds-button--tertiary ds-button--large">
                  {
                    REGIST_TRANS_TYPE === "REGIST_GUID"
                      ? <button className="ds-button__trigger" type="button" onClick={this.close}>
                          <span className="ds-button__label">{messageList.moblienumberChange.M014_close}</span>
                        </button>
                      : <button className="ds-button__trigger" type="button" onClick={this.beforeOtpChange}>
                          <span className="ds-button__label">{messageList.moblienumberChange.M014_back}</span>
                        </button>
                  }
                </div>
              </div>
            </div>
          </div>

          {/* 案内表示部 */}
          <div className="contentInner">
            <div className="ds-heading ds-heading--sm">
              <h2 className="ds-heading__title">{messageList.moblienumberChange.M015_notices}</h2>
            </div>
            <ul className="ds-listText ds-listText--md">
              <li className="ds-listText__item">{messageList.moblienumberChange.M016_notice001}</li>
              <li className="ds-listText__item">{messageList.moblienumberChange.M016_notice002}</li>
              <li className="ds-listText__item">{messageList.moblienumberChange.M016_notice003}</li>
            </ul>
          </div>

        </section>
      );
    }

    // 携帯電話番号登録変更画面表示
    else if (this.state.dispKbn === 1) {
      return (
        <section className="content">
          <Helmet
            title={messageList.moblienumberChangeSetting.M001_browserTitle} >
          </Helmet>

          { // Loadingモーダル表示
            this.state.loading &&
            <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading" /></div>
          }

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 className="ds-heading__title">{messageList.moblienumberChangeSetting.M002_pageTitle}</h1>
          </div>

          <div className="contentInner">
            {/* サブタイトル表示部 */}
            <div className="ds-heading ds-heading--sm">
              <h2 className="ds-heading__title">{messageList.moblienumberChangeSetting.M003_pageTitleSub}</h2>
            </div>

            <p className="ds-text">
              {messageList.moblienumberChangeSetting.M004_mobileNumberChangeSettingText001}
              {this.state.phonenumber.substring(0, 3) + '-' + this.state.phonenumber.substring(3, 7) + '-' + this.state.phonenumber.substring(7, 11)}
              {messageList.moblienumberChangeSetting.M004_mobileNumberChangeSettingText002}<br />
              {messageList.moblienumberChangeSetting.M005_mobileNumberChangeSettingText002}
            </p>

            <a href={messageList.moblienumberChangeSetting.M017_noticeUrl001} target="_blank" rel="noopener noreferrer" className="ds-textLink ds-textLink--linkBlank u-fw-bold">
              {messageList.moblienumberChangeSetting.M007_onetimePassword}&nbsp;
              <span className="ds-textLink__icon">
                <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.moblienumberChangeSetting.M006_newWindowIcon}>
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                </svg>
              </span>
            </a>

            <div id="JS_error">
              { // エラーメッセージ表示
                (this.state.errorMap && this.state.errorMap.ERROR) &&
                <div className="ds-inlineNote ds-inlineNote--attention u-mb-32--pc" role="alert" aria-live="assertive">
                  <div className="ds-inlineNote__details">
                    <div className="ds-inlineNote__summary">
                      <h2 className="ds-inlineNote__heading">
                        <span className="ds-inlineNote__headingIcon">
                          <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.moblienumberChangeSetting.M008_errorIconText}>
                            <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                          </svg>
                        </span>
                        <span className="ds-inlineNote__headingLabel">{messageList.moblienumberChangeSetting.M009_errorBoxTitle}</span>
                      </h2>
                    </div>
                    <div className="ds-inlineNote__content">
                      <p className="ds-text">{this.state.errorMap.ERROR}</p>
                    </div>
                  </div>
                </div>/* /ds-inlineNote */
              }
            </div>

            <div className="formPanel">
              <div className="formPanel__inner">
                <form name="form">
                  <div className="formWrap">
                    <label className="formLabel" htmlFor="LB_input-tel">
                      <span className="formLabel__text">{messageList.moblienumberChangeSetting.M010_confirmCode}</span>
                    </label>
                    <input id="LB_input-tel" name="authCode"
                      className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('authCode') ?
                        "ds-textfield is-error" : "ds-textfield"}
                      type="text" required
                      aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('authCode') ? "true" : "false"}
                      autoComplete="one-time-code" maxLength="6" inputMode="numeric"
                      value={this.state.authCode} onChange={this.handleChange} onKeyPress={this.handleKeyPress} />
                    {/* 暗黙的Submit抑止用の空inputタグ */}
                    <input type="text" style={boxStyle} />
                  </div>

                  {/* 送信ボタン */}
                  <div className="buttonLayout">
                    <div className="buttonWrap buttonWrap--center">
                      <div className="ds-button ds-button--primary ds-button--large">
                        <button className="ds-button__trigger" type="button" formNoValidate onClick={this.change}>
                          <span className="ds-button__label">{messageList.moblienumberChangeSetting.M011_send}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* 戻るボタン */}
            <div className="buttonLayout">
              <div className="buttonWrap buttonWrap--left">
                <div className="ds-button ds-button--tertiary ds-button--large">
                  <button className="ds-button__trigger" type="button" onClick={this.beforeMobilenumberChange}>
                    <span className="ds-button__label">{messageList.moblienumberChangeSetting.M012_back}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* 案内表示部 */}
          <div className="contentInner">
            <div className="ds-heading ds-heading--sm">
              <h2 className="ds-heading__title">{messageList.moblienumberChangeSetting.M013_notices}</h2>
            </div>
            <ul className="ds-listText ds-listText--md">
              <li className="ds-listText__item">{messageList.moblienumberChangeSetting.M014_notice001}</li>
              <li className="ds-listText__item">{messageList.moblienumberChangeSetting.M014_notice002}</li>
              <li className="ds-listText__item">{messageList.moblienumberChangeSetting.M014_notice003}</li>
            </ul>
          </div>

        </section>
      );
    }

    // 携帯電話番号登録変更完了画面表示
    else {
      return (
        <section className="content">
          <Helmet
            title={messageList.moblienumberChangeCompletion.M001_browserTitle} >
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 className="ds-heading__title">
              {
                REGIST_TRANS_TYPE === "REGIST_GUID"
                  ? messageList.moblienumberChangeCompletion.M002_pageTitle_regist
                  : messageList.moblienumberChangeCompletion.M002_pageTitle
              }
            </h1>
          </div>

          <div className="contentInner">
            {/* ガイドメッセージ表示部 */}
            {
              REGIST_TRANS_TYPE !== "REGIST_GUID" &&
              <p className="ds-text">
                {messageList.moblienumberChangeCompletion.M004_guideMessage001}<br />
                {messageList.moblienumberChangeCompletion.M005_guideMessage002}<br />
                {messageList.moblienumberChangeCompletion.M006_guideMessage003}
              </p>
            }
            {
              REGIST_TRANS_TYPE === "REGIST_GUID" &&
              <p className="ds-text">
                {messageList.moblienumberChangeCompletion.M006_guideMessage003}
              </p>
            }

            <div className="u-w-4of12--pc u-mt-48--pc u-mt-40--sp imgCenter">
              <img src={`${process.env.PUBLIC_URL}/assets/img/icon_passkey.svg`} className="u-img-full u-w-full" alt="" aria-hidden="true" />
            </div>

            {/* 操作ボタン表示部 */}
            <div className="buttonLayout">
              <div className="buttonWrap buttonWrap--center">
                <div className="ds-button ds-button--primary ds-button--large">
                  <button className="ds-button__trigger" type="button" onClick={this.toPasskey}>
                    <span className="ds-button__label">{messageList.moblienumberChangeCompletion.M007_passkeyLogin}</span>
                  </button>
                </div>
              </div>
              <div className="buttonWrap buttonWrap--left">
                <div className="ds-button ds-button--tertiary ds-button--large">
                  {
                    REGIST_TRANS_TYPE === "REGIST_GUID"
                      ? <button className="ds-button__trigger" type="button" onClick={this.close}>
                          <span className="ds-button__label">{messageList.moblienumberChangeCompletion.M003_close}</span>
                        </button>
                      : <button className="ds-button__trigger" type="button" onClick={this.beforeOtpChange}>
                          <span className="ds-button__label">{messageList.moblienumberChangeCompletion.M003_back}</span>
                        </button>
                  }
                </div>
              </div>
            </div>
          </div>

        </section>
      );
    }
  }
}

export default MobilenumberChange
